import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayProcessProvider {

  private _service: string = 'payroll';
  private _model: string = 'payProcess';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getReviewData(periodCode: string, paydate: string, skip: string | number, limit: string | number): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getReviewData';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getReviewDataPeriod(periodCode: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getReviewData';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getAllowDeduct(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getAllowDeduct';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body)
  }

  public updateempcomperiod(params: any): Observable<any> {
    const _method: string = "POST";
    const _func: string = "newUpdateempcomperiod";
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public processPayrollQueue(periodCode: string, ListEmpID: any[]): Observable<any> {
    const _method: string = "POST";
    const _func: string = "processPayrollQueue";
    const _params: any = {
      periodCode,
      ListEmpID,
    } || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getPayrollProcessLog(periodCode: string, paydate: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPayrollProcessLog';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getSummaryPayroll(periodCode: string, paydate: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getSummaryPayroll';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/pay-process/pay-process.ts